import { useEffect } from "react";

type MetaConfig = {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
};

function setNamedMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function usePageMeta({ title, description, keywords, canonical }: MetaConfig) {
  useEffect(() => {
    document.title = title;
    setNamedMeta("name", "description", description);
    if (keywords) setNamedMeta("name", "keywords", keywords);
    setNamedMeta("property", "og:title", title);
    setNamedMeta("property", "og:description", description);
    setNamedMeta("name", "twitter:title", title);
    setNamedMeta("name", "twitter:description", description);

    if (canonical) {
      let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
      setNamedMeta("property", "og:url", canonical);
    }
  }, [title, description, keywords, canonical]);
}